module.exports = __webpack_public_path__ + "img/cocosisland.03890c40.svg";